import { Component, OnInit, AfterViewInit, HostListener } from '@angular/core';
import { AuthService } from '../auth.service';
import { AppCommonService } from '../appcommon.service';
import { HeaderAndNavigationService } from '../headerandnavigation/headerandnavigation.service';
import { IOffer } from '../blogs/blog';
import { BlogService } from '../blogs/blog.service';
declare var $: any;
@Component({  
  templateUrl: "./mybusinessadvantage.new.component.html"
})
export class MyBusinessAdvantageNewComponent implements OnInit, AfterViewInit {
  @HostListener('window:resize', ['$event'])
  sizeChange(event) {
    //console.log('size changed.', event);
  }
  offersList: IOffer[];
  categoryList: IOffer[];
  category: string = "";
  public pageTitle: string = 'My Business Advantage';
  constructor(
    private authService: AuthService,
    private appCommonService: AppCommonService,
    public blogService: BlogService,
    public headerAndNavigationService: HeaderAndNavigationService,
  ) {
    this.appCommonService.pageName = this.pageTitle;
    this.appCommonService.pageContentAdditionalClass = "dashboard-page";
  }
  ngOnInit() {
    this.headerAndNavigationService.showhideNav(true, false);
    this.loadOffersList();
  }

  ngAfterViewInit() {
    $(".regular").slick({
      dots: false,
      infinite: true,
      slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: true,
                    dots: true
                }
            },
        ]
    });
  }

  showCategory(id) {    
    if (id == 0) {
      this.categoryList = this.offersList;
    }
    else {
      this.categoryList = this.offersList.filter(f => f.offer_category.find(c => c === id));
    }
    this.category = id;
    this.triggerResize();
  }

  triggerResize() {
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 500);
  }

  loadOffersList() {
    this.blogService.getOffersList()
      .subscribe(
      (offers: IOffer[]) => {
        this.offersList = offers;
        this.categoryList = offers;
        this.triggerResize();
      },
      (error: any) => {
        this.blogService.showError("Offers retrieval problem", <any>error)
      }
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/home/mybusinessadvantage.new.component.ts